import { render, staticRenderFns } from "./DIVEMetadataClone.vue?vue&type=template&id=c4e64068&scoped=true"
import script from "./DIVEMetadataClone.vue?vue&type=script&lang=ts"
export * from "./DIVEMetadataClone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e64068",
  null
  
)

export default component.exports